import { useState } from 'react';
import { Link } from 'react-router-dom';
import {
  DeleteFilled,
  EditFilled,
  PlusCircleOutlined,
  SearchOutlined,
} from '@ant-design/icons';
import { Button, Card, Col, Input, Row, Table, Tag } from 'antd';
import { useFetch } from '@/hooks';
import { globalSearch } from '@/utils/search/Search';
import { DeleteModal } from './deleteModal';
import { handleDeleteApi } from '@/api/crud';
import { useVersionMenus } from './query';

/**
 * roles list component
 * @returns
 */

const columns = [
  {
    title: 'S.N',
    dataIndex: 'index',
    key: 'index',
    align: 'center',
    width: 50,
  },
  {
    title: 'Version Name',
    dataIndex: 'versionName',
    key: 'versionName',
    align: 'left',
  },
  {
    title: 'Menu Name',
    dataIndex: 'menuName',
    key: 'menuName',
    align: 'center',
  },
  {
    title: 'Action',
    dataIndex: 'action',
    key: 'action',
    align: 'center',
    width: 100,
  },
];

const SuperadminVersionMenuMappingList = () => {
  const [searchQuery, setSearchQuery] = useState('');
  const { data } = useVersionMenus();
  return (
    <>
      <div className="table">
        <Row gutter={[24, 0]}>
          <Col xs={24} xl={24}>
            <Card
              variant="outlined"
              title={
                <Link to="/superadmin/version/menu/mapping/create/">
                  <Button className="centered" size="medium" type="primary">
                    <PlusCircleOutlined />
                    Create
                  </Button>
                </Link>
              }
              extra={
                <div className="flex flex-col items-center justify-center gap-[10px]">
                  <Input
                    className="header-search"
                    name="query"
                    placeholder="Search Role..."
                    value={searchQuery}
                    prefix={<SearchOutlined />}
                    onChange={(event) => setSearchQuery(event.target.value)}
                  />
                </div>
              }
            >
              <div className="overflow-x-auto">
                <Table
                  size="large"
                  bordered
                  tableLayout="auto"
                  onHeaderRow={() => ({
                    style: { whiteSpace: 'nowrap' },
                  })}
                  columns={columns?.map((col) => ({
                    ...col,
                    onCell: () => ({
                      style: { padding: '6px 10px' },
                    }),
                  }))}
                  scroll={{ x: true }}
                  className="ant-border-space"
                  style={{ textAlign: 'center', padding: '15px' }}
                  pagination={{
                    hideOnSinglePage: true,
                  }}
                  dataSource={
                    data?.data
                      ? globalSearch(data?.data, searchQuery)?.map(
                          (version, index) => {
                            return {
                              key: version.versionId,
                              index: index + 1,
                              menuName: (
                                <span className="font-bold cursor-pointer w-ellipsis">
                                  {version.menus
                                    ?.slice(0, 3)
                                    .map((item, index) => (
                                      <Tag
                                        key={index}
                                        color={
                                          index % 2 === 0 ? 'green' : 'blue'
                                        }
                                      >
                                        {item.menuName}
                                      </Tag>
                                    ))}
                                  {version.menus?.length > 3 && (
                                    <span className="text-gray-500">
                                      ... {version.menus.length - 3} more
                                    </span>
                                  )}
                                </span>
                              ),
                              versionName: version.versionName,
                              action: (
                                <div className="tw-flex tw-justify-center tw-items-center tw-gap-4">
                                  <div className="ant-button-edit">
                                    <Link
                                      size="medium"
                                      className="edit"
                                      to={`/superadmin/version/menu/mapping/${version.versionId}/edit/`}
                                    >
                                      <EditFilled className="text-blue-300" />
                                    </Link>
                                  </div>
                                  <div className="ant-button-delete">
                                    <DeleteModal id={version.versionId} />
                                  </div>
                                </div>
                              ),
                            };
                          },
                        )
                      : []
                  }
                />
              </div>
            </Card>
          </Col>
        </Row>
      </div>
    </>
  );
};

export default SuperadminVersionMenuMappingList;
